import React, { Component } from 'react';

import withStyles from '@material-ui/core/styles/withStyles';

import MyButton from '../../util/myButton';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';
import DeleteOutline from '@material-ui/icons/DeleteOutline';
import PropTypes from 'prop-types';

//icons


import { connect } from 'react-redux';
import { deleteSoundOff } from '../../redux/actions/dataActions';
import { Button } from '@material-ui/core';

const styles = (theme) => ({
    ...theme.spread,
    deleteButton: {
        position: 'absolute',
        left: '90%',
        top: '10%',

    }
});

class DeleteSoundOff extends Component {
    constructor(props) {
        super(props);
        this.state = {
            open: false
        }
    }
    handleOpen = () => {
        this.setState(() => {
            return {
                open: true
            }
        })
    }
    handleClose = () => {
        this.setState(() => {
            return {
                open: false
            }
        })
    }
    deleteSoundOff = () => {
        this.props.deleteSoundOff(this.props.soundOffId)

        this.setState(() => {
            return {
                open: false
            }
        })
    }
    render() {
        const { classes } = this.props;
        return (
            <React.Fragment>
                <MyButton tip='Delete' onClick={this.handleOpen} btnClassName={classes.deleteButton}>
                    <DeleteOutline color='primary' />
                </MyButton>
                <Dialog open={this.state.open} onClose={this.handleClose} fullWidth maxWidth='sm'>
                    <DialogTitle>
                        Are you sure you want to delete your soundoff?
                    </DialogTitle>
                    <DialogActions>
                        <Button onClick={this.handleClose} color='primary'>Cancel</Button>
                    </DialogActions>
                    <DialogActions>
                        <Button onClick={this.deleteSoundOff} color='primary'>Delete</Button>
                    </DialogActions>
                </Dialog>
            </React.Fragment>
        )
    }
}

DeleteSoundOff.propTypes = {
    deleteSoundOff: PropTypes.func.isRequired,
    classes: PropTypes.object.isRequired,
    soundOffId: PropTypes.string.isRequired
};



export default connect(null, { deleteSoundOff })(withStyles(styles)(DeleteSoundOff));
